import { useEffect, useState, useContext } from "react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

export const useHotels = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [hotels,  setHotels]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    axios
      .get(`${baseUrl}/customer/hotels`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        const raw = response.data?.data || [];

        const mapped = raw.map((hotel) => ({
          id:         hotel.id,
          vendorId:   hotel.jjvendor_id || hotel.vendor_id || null,
          name:       hotel.hotel_name,
          starRating: hotel.stars|| 0,
          location:   hotel.address         || 'N/A',
          price:      hotel.jjrooms?.[0]?.price || 0,
          checkIn:    hotel.check_in_time   || 'N/A',
          checkOut:   hotel.check_out_time  || 'N/A',
          description:hotel.description    || '',
          facilities: Array.isArray(hotel.facilities)
                        ? hotel.facilities
                        : typeof hotel.facilities === 'string'
                          ? JSON.parse(hotel.facilities)
                          : [],
          image:      hotel.hotel_image
                        ? `${baseUrl.replace('/api', '')}/storage/${hotel.hotel_image}`
                        : 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800',

          rooms: (hotel.jjrooms || [])
            .filter((room) => room.status === 'Available')
            .map((room) => ({
              id:        room.id,
              number:    room.room_number || 'N/A',
              name:      room.room_type,
              type:      room.room_type,
              price:     room.price      || 0,
              capacity:  room.capacity   || 'N/A',
              floor:     room.floor      || 'N/A',
              status:    room.status     || 'available',
              amenities: room.amenities  || [],
              images:    (room.jjroomimages || []).map(
                (img) => `${baseUrl.replace('/api', '')}/storage/${img.image_path}`
              ),
            })),
        }));

        setHotels(mapped);
      })
      .catch((err) => {
        console.error('Hotels fetch error:', err);
        setError('Unable to load hotels');
      })
      .finally(() => setLoading(false));
  }, [baseUrl, authToken]);

  return { hotels, loading, error };
};